import * as React from "react"

const IconWarning = (props) => (
  <svg
    width={64}
    height={64}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m54.172 51.248-31.593 8.47c-4.25 1.146-8.591-1.386-9.737-5.636l-8.47-31.593c-1.146-4.251 1.386-8.592 5.636-9.738l31.594-8.47c4.25-1.146 8.591 1.386 9.737 5.637l8.47 31.593c1.116 4.22-1.386 8.591-5.637 9.737Z"
      fill="#D7DBF5"
    />
    <path
      d="M38.888 1.779 16.912 28.85a2.636 2.636 0 0 0 .633 4.04l34.306 19.806c2.02 1.175 4.462-.724 3.829-2.985L43.44 3.77c-.301-1.025-.964-1.9-1.899-2.412-.874-.513-1.96-.332-2.653.422Z"
      fill="#141938"
    />
    <path
      d="m36.627 2.954 2.804-1.628 15.013 51.339-2.804 1.598L36.627 2.954Z"
      fill="#141938"
    />
    <path
      d="M36.175 3.316 14.2 30.387a2.636 2.636 0 0 0 .633 4.04l34.306 19.776c2.02 1.175 4.462-.724 3.829-2.985L40.757 5.306c-.301-1.025-.964-1.9-1.899-2.412-.874-.512-1.99-.332-2.683.422Z"
      fill="#FAFBFF"
    />
    <path
      d="M36.658 7.235 17.756 30.96c-.573.633-.422 1.658.332 2.08l29.814 17.214c.784.452 1.749-.272 1.477-1.146L38.497 7.838a1.306 1.306 0 0 0-.603-.784c-.392-.24-.905-.15-1.236.181Z"
      fill="#FAAF37"
    />
    <path
      d="M37.743 16.31c.844.451.844 1.507.633 2.23l-2.683 11.998c-.211.663-.724.935-1.327.603-.602-.332-.994-1.085-.934-1.809l.693-13.174c.06-.783.784-1.356 1.477-1.115l2.14 1.266ZM34.065 32.799c-1.266-.482-2.351.12-2.592 1.357v.06c-.242 1.236.512 2.532 1.778 2.984 1.266.483 2.352-.12 2.593-1.356v-.06c.24-1.206-.543-2.503-1.779-2.985Z"
      fill="#FF1C44"
    />
  </svg>
)

export default IconWarning
